import * as sysModule from '@/api/sysModule'
const actions = {
  moduleTree({}, parm) {
    return new Promise((resolve, reject) => {
      sysModule.moduleTree(parm).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  actions
}